// extracted by mini-css-extract-plugin
export default {"grayBody":"Comment-grayBody___5063d46a808542a8348","reply":"Comment-reply___4dc6cc249e778242dda"};